

export const frontMatter = {
	sidebar_position: 3,
	license: 'republish',
	author: 'Jan van Steenbergen',
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/design-criteria.html'
};
export const contentTitle = 'Критерії дизайну';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-uk-docusaurus-plugin-content-docs-current-learn-misc-design-criteria-md-992.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Фонологія та письмо",
  "id": "phonology-and-writing",
  "level": 2
}, {
  "value": "Словниковий запас",
  "id": "vocabulary",
  "level": 2
}, {
  "value": "Інтернаціональна проти слов&#39;янської лексики",
  "id": "international-versus-ѕlavic-vocabulary",
  "level": 3
}, {
  "value": "Які корені використовувати?",
  "id": "which-roots-to-use",
  "level": 3
}, {
  "value": "Фальшиві друзі",
  "id": "false-friends",
  "level": 3
}, {
  "value": "Неологізми",
  "id": "neologisms",
  "level": 3
}, {
  "value": "Як встановити правильну форму для кореня?",
  "id": "how-to-establish-the-right-form-for-a-root",
  "level": 3
}, {
  "value": "Граматика",
  "id": "grammar",
  "level": 2
}, {
  "value": "Простий рівень",
  "id": "simple-level",
  "level": 3
}, {
  "value": "Просунутий рівень",
  "id": "advanced-level",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "критерії-дизайну",
        children: "Критерії дизайну"
      })
    }), "\n", _jsx(_components.p, {
      children: "Міжслов’янство базується на спільній спадщині всіх слов’янських народів, а розбіжності долаються шляхом досягнення компромісів. До всіх слов’янських мов ставляться однаково, хоча не можна уникнути того, що слов’янська міжмова ближча до «середніх» мов, таких як словацька чи русинська, ніж до периферійних мов, таких як сорбська чи македонська. Міжслов’янська мова явно не має на увазі бути «більш слов’янською, ніж слов’яни», очищаючи її від іноземних впливів, навіть якщо мова, заснована на спільності слов’янських мов, у будь-якому випадку автоматично усуне багато місцевих (неслов’янських) впливів. Проте немає жодних причин виключати інтернаціональну лексику за умови, що її можуть розпізнати всі або принаймні більшість носіїв слов’янських мов."
    }), "\n", _jsx(_components.p, {
      children: "Основна мета міжслов’янської мови — максимальна зрозумілість для всіх слов’ян — досягається шляхом систематичного надання найбільшого спільного знаменника слов’янських мов, як з точки зору граматики, орфографії, синтаксису, так і лексики. Коли спільного рішення знайти не вдається, ми шукаємо компроміс. Якщо навіть компроміс неможливий, ми повинні зробити вибір або просто запропонувати обидва рішення."
    }), "\n", _jsx(_components.p, {
      children: "Другорядне призначення полягає в тому, що його можна легко засвоїти і використовувати, перш за все слов'янами, але також і неслов'янами. Очевидно, слов'янська мова з граматикою, яка складається з десяти простих правил, неможлива. Проте ми намагаємося зберегти граматику максимально простою та правильною, не жертвуючи слов’янським характером мови."
    }), "\n", _jsx(_components.p, {
      children: "У цьому розділі детально описано, як досягаються ці дві цілі."
    }), "\n", _jsx(_components.h2, {
      id: "phonology-and-writing",
      children: "Фонологія та письмо"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Основні принципи дизайну щодо фонології та письма такі:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Як правило, і те, і інше має бути максимально знайомим для носіїв слов’янських мов. Тому ми працюємо з обмеженою кількістю звуків і уникаємо включення неслов’янських елементів."
      }), "\n", _jsx(_components.li, {
        children: "Будь-яка людина повинна вміти писати Interslavic на власній клавіатурі, без спеціальних пристосувань і так, щоб це було природно."
      }), "\n", _jsx(_components.li, {
        children: "Оскільки поділ між латиницею та кирилицею проходить через середину слов’янської території, до обох ставляться однаково."
      }), "\n", _jsx(_components.li, {
        children: "Ми не прихильники приписів щодо вимови. Ми лише даємо основні позначення, а щодо решти, будь-хто має вимовляти міжслов’янську так, як йому зручно та природно. Жодна вимова не є «правильнішою», ніж інша. Подібним чином наголошення в словах є вільним."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["В ідеалі на будь-якій слов’янській клавіатурі має бути можливість писати міжслов’янську. Однак є одна проблема: ці клавіатури розроблено відповідно до стандартних національних орфографій, і кожна з цих орфографій була адаптована відповідно до потреб певної мови. Близько половини слов’янських мов використовують латинський алфавіт, іншу половину пишуть кирилицею, і обидва алфавіти існують у двох взаємовиключних варіантах: чеська, словацька, словенська та хорватська використовують латинський алфавіт з ", _jsx(_components.code, {
        children: "v"
      }), ", ", _jsx(_components.code, {
        children: "š"
      }), ", ", _jsx(_components.code, {
        children: "ž"
      }), "  тощо, польський з @ @81 Російська, українська, білоруська та болгарська використовують кириличний алфавіт із ", _jsx(_components.code, {
        children: "й"
      }), ", ", _jsx(_components.code, {
        children: "ь"
      }), ", ", _jsx(_components.code, {
        children: "ю"
      }), ", , сербський і македонський з ", _jsx(_components.code, {
        children: "ј"
      }), ", ", _jsx(_components.code, {
        children: "љ"
      }), "  та ", _jsx(_components.code, {
        children: "џ"
      }), ". Не нам вирішувати, що один шлях є «кращим» або «більш слов’янським» за інший. Крім того, будь-якому слов'янинові має бути зручно писати міжслов'янську, тому ми повинні змиритися з тим, що її можна писати різними способами."]
    }), "\n", _jsxs(_components.p, {
      children: ["Оскільки ", _jsx(TransliteratorElement, {
        children: "końe"
      }), ", ", _jsx(TransliteratorElement, {
        children: "koňe"
      }), ", ", _jsx(TransliteratorElement, {
        children: "konje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "konie"
      }), "  і ", _jsx(TransliteratorElement, {
        children: "kone"
      }), " — це просто різні, природні способи написання того самого слова, немає сенсу обговорювати, яку версію слід зробити «офіційною», оскільки будь-який такий вибір автоматично зробить інші версії «неофіційними». “ і тому „неправильно” або принаймні „нестандартно”. Тому ми дотримуємося зовсім іншого підходу: замість вибору будь-якого виду офіційної орфографії ми працюємо з ", _jsx(_components.strong, {
        children: "прототипом орфографії"
      }), ". Якщо припустити, що всі різні рішення, які використовуються в національних правописах, стосуються одного ", _jsx(_components.strong, {
        children: "прототипу"
      }), ", ми також вважаємо цей прототип найкращим способом представлення міжслов’янської мови. Оскільки ми маємо справу з двома абсолютно різними алфавітами (латинською та кирилицею), ми не можемо уникнути наявності одного прототипу орфографії для кожного з них."]
    }), "\n", _jsx(_components.p, {
      children: "В ідеалі обидва прототипи повинні мати такі характеристики:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "вони повинні бути інтуїтивно зрозумілими кожному, хто вміє читати даний алфавіт"
      }), "\n", _jsx(_components.li, {
        children: "вони мають бути логічними, послідовними, однозначними та етимологічно правильними"
      }), "\n", _jsx(_components.li, {
        children: "вони повинні давати пристойне наближення до правильної вимови"
      }), "\n", _jsx(_components.li, {
        children: "по можливості одна фонема (звук) = один символ"
      }), "\n", _jsx(_components.li, {
        children: "вони мають бути сумісними (проста транслітерація, бажано одна на основі 1:1)"
      }), "\n", _jsx(_components.li, {
        children: "вони не повинні містити неприродні елементи"
      }), "\n", _jsxs(_components.li, {
        children: ["вони не повинні бути потворними чи образливими (наприклад, ", _jsx(_components.code, {
          children: "йа"
        }), " або ", _jsx(_components.code, {
          children: "łi"
        }), "), але також не повинні обмежуватися специфікою будь-якої національної мови"]
      }), "\n", _jsx(_components.li, {
        children: "вони правильно відображаються на середньостатистичному екрані комп'ютера, тому слід уникати символів із незвичайних наборів символів, поєднання діакритики тощо."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Оскільки жодна з існуючих слов’янських орфографій не може задовольнити всі ці вимоги, ми розрізняємо базовий алфавіт, що складається з фонем, які можна знайти в кожній слов’янській мові, та низку необов’язкових розширень, які можна використовувати як засіб для більшої чіткості вимови. , етимологія тощо."
    }), "\n", _jsx(_components.h2, {
      id: "vocabulary",
      children: "Словниковий запас"
    }), "\n", _jsx(_components.h3, {
      id: "international-versus-ѕlavic-vocabulary",
      children: "Інтернаціональна проти слов'янської лексики"
    }), "\n", _jsx(_components.p, {
      children: "В ідеалі кожне слово має бути знайомим кожному носії слов’янської мови. Навіть якщо певна форма слова не зустрічається в чиїйсь власній мові, вона повинна принаймні викликати певний відтінок, який дає підказку в правильному напрямку. Очевидно, що це не завжди можливо, і, отже, потрібні кілька механізмів, щоб вирішити, як вибирати словниковий запас. Перший і найважливіший крок — це збір коренів слів, які впізнають усі або більшість слов’ян. Згодом ці корені можуть служити основою для розширення словникового запасу шляхом побудови сполук."
    }), "\n", _jsx(_components.p, {
      children: "Існує два типи лексики, які відіграють ключову роль у покращенні взаємного розуміння між двома різними мовами:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["інтернаціональна лексика, слова, поширені в багатьох, навіть неспоріднених мовах. Більшість його було запозичено прямо чи опосередковано з латинської та грецької (", _jsx(TransliteratorElement, {
          children: "filozofija"
        }), ", ", _jsx(TransliteratorElement, {
          children: "universitet"
        }), ", ", _jsx(TransliteratorElement, {
          children: "material"
        }), ", ", _jsx(TransliteratorElement, {
          children: "motor"
        }), "), іноді воно походить з інших мов (", _jsx(TransliteratorElement, {
          children: "bjuro"
        }), ", ", _jsx(TransliteratorElement, {
          children: "fajl"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jaguar"
        }), ", ", _jsx(TransliteratorElement, {
          children: "čaj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "šokolad"
        }), ")), у рідкісних випадках навіть із самої слов’янської (", _jsx(TransliteratorElement, {
          children: "vampir"
        }), ", ", _jsx(TransliteratorElement, {
          children: "vodka"
        }), ")"]
      }), "\n", _jsx(_components.li, {
        children: "загальна успадкована лексика, іншими словами, лексика, яку обидві мови успадкували від спільного предка, в даному конкретному випадку праслов'янського"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Інтернаціональні слова є невід'ємною частиною кожної слов'янської мови. Їхня перевага полягає в тому, що вони, як правило, практично ідентичні в різних мовах, як за формою, так і за значенням, і тому є чудовим рішенням для міжслов’янської мови, особливо для більш освічених. У випадку з успадкованою лексикою ситуація дещо складніша, оскільки кожна мова пройшла свій характерний розвиток, і в результаті слово в одній мові може бути не відразу впізнаваним для носіїв іншої, навіть якщо це мова те саме слово. Порівняйте, наприклад, польське ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "węgiel"
      }), " і словацьке ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sk",
        children: "uhlie"
      }), " «вугілля». Крім того, у кількох випадках їхні значення відійшли настільки далеко одне від одного (наприклад, ", _jsx(TransliteratorElement, {
        children: "duma"
      }), ", що означає «думка» російською та «гордість» польською), що їх можна вважати ", _jsx(_components.em, {
        children: "фальшивими друзями"
      }), ", тобто словами, які легко можуть бути неправильно зрозумілий навіть у правильному контексті."]
    }), "\n", _jsxs(_components.p, {
      children: ["Обсяг міжнародної лексики обмежений, і він не буде корисним для багатьох повсякденних понять. Крім того, є люди, які просто ", _jsx(_components.em, {
        children: "не люблять"
      }), " вживати його слов'янською. З цієї причини ми також намагаємося надати широко зрозумілі слов’янські альтернативи. Однак це не завжди можливо. Наприклад, одні слов'янські народи використовують латинські назви місяців, інші — слов'янські. Останні набагато менш уніфіковані: ", _jsx(TransliteratorElement, {
        children: "listopad"
      }), " польською мовою означає «листопад», а хорватською — «жовтень» (типовий приклад фальшивого друга), тоді як лише білорус може сказати, який місяць мається на увазі під ", _jsx(TransliteratorElement, {
        children: "kastryčnik"
      }), ". Тому до слов’янських відповідників інтернаціональних слів слід ставитися обережно."]
    }), "\n", _jsxs(_components.p, {
      children: ["Інтернаціональна лексика приймається лише за умови використання в більшості слов’янських мов. У міжслов’янській мові використовуються певні фіксовані механізми її запозичення, які можна знайти в ", _jsx(_components.a, {
        href: "/uk/learn/vocabulary/derivation",
        children: "спеціальному розділі"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Коли йдеться про загальноуспадковану (слов’янську) лексику, нам потрібно зробити три речі: вибрати слова та корені слів, встановити для них правильну форму та надати їм основне значення."
    }), "\n", _jsx(_components.h3, {
      id: "which-roots-to-use",
      children: "Які корені використовувати?"
    }), "\n", _jsx(_components.p, {
      children: "Коли потрібно нове слово, ми починаємо з інвентаризації слів, які використовують для нього різні слов’янські мови. Залежно від результату ми робимо:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Коли корінь слова існує в усіх слов’янських мовах в однаковому значенні, то це легко: ми з вдячністю переймаємо його."
      }), "\n", _jsx(_components.li, {
        children: "Коли розходяться тільки одна чи дві мови, ми робимо те саме."
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо можна виділити дві чи більше груп, кожна з яких базується на окремому слов’янському корені, ми діємо таким чином:", "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "для кожного з цих коренів ми шукаємо споріднені в інших мовах разом із їхніми значеннями,"
          }), "\n", _jsx(_components.li, {
            children: "згодом ми робимо те саме для цих коренів і значень, таким чином створюючи «семантичні сім’ї»,"
          }), "\n", _jsx(_components.li, {
            children: "нарешті, ми вибираємо ті слова, які зустрічаються в усіх або більшості мов, і надаємо їм найбільш «середні» значення."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо це також не спрацює, у нас є кілька варіантів:", "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "ми вибираємо слово, яке зустрічається в більшості мов"
          }), "\n", _jsx(_components.li, {
            children: "ми аналізуємо, які слова більш інтуїтивно зрозумілі, ніж інші, навіть якщо вони вживаються лише в одній мові"
          }), "\n", _jsx(_components.li, {
            children: "утворюємо синоніми"
          }), "\n", _jsx(_components.li, {
            children: "ми надаємо більшим і відомішим мовам перевагу над меншими"
          }), "\n", _jsx(_components.li, {
            children: "ми шукаємо «міжнародний» еквівалент"
          }), "\n", _jsx(_components.li, {
            children: "ми щось «проектуємо»."
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "При застосуванні цього процесу всі три підродини (східна, західна та південнослов’янська) розглядаються на рівній основі. Ми старанно уникаємо надавати перевагу одній мові над іншою, що не завжди легко, тому що одна мова (російська) набагато більша за всі інші за кількістю носіїв, а кілька менших мов (наприклад, сербська, боснійська та хорватська) настільки схожі на кожну з іншого боку, їх можна легко розглядати як діалекти однієї мови. Щоб досягти справедливого ставлення до мов під час зважування їх внеску, ми використовуємо систему з шести підгруп, і кожній з цих підгруп надається один «голос»:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "російський"
      }), "\n", _jsx(_components.li, {
        children: "українською та білоруською"
      }), "\n", _jsx(_components.li, {
        children: "польський"
      }), "\n", _jsx(_components.li, {
        children: "чеська та словацька"
      }), "\n", _jsx(_components.li, {
        children: "словенська та сербська/хорватська/боснійська"
      }), "\n", _jsx(_components.li, {
        children: "болгарська та македонська"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Якщо дві мови в одній групі не згодні щодо слова, ½ голосу надається одній, а ½ голосу – іншій. Якщо два слова кандидата мають однакову кількість голосів, вирішує населення. На практиці це означає, що російська завжди виграє, що цілком резонно, враховуючи той факт, що близько 70% слов'ян знають цю мову."
    }), "\n", _jsx(_components.p, {
      children: "З практичних міркувань мови, носіями яких менше одного мільйона, як-от сорбська, кашубська та русинська, не беруть участі в голосуванні. Однак це не означає, що вони взагалі не беруться до уваги."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "http://steen.free.fr/interslavic/voting_machine.html",
        children: "Автомат для голосування"
      }), " – це інструмент, який застосовує ці правила. Слід зазначити, що ці правила є загальною тенденцією; коли інше рішення очевидно краще, здоровий глузд завжди повинен переважати."]
    }), "\n", _jsx(_components.h3, {
      id: "false-friends",
      children: "Фальшиві друзі"
    }), "\n", _jsxs(_components.p, {
      children: ["Індивідуальний розвиток слов'янських слів у різних мовах, включаючи іноді серйозний дрейф у значеннях, породив існування багатьох схожих на вигляд слів із абсолютно різними значеннями в різних мовах. Ці слова відомі як «фальшиві друзі», і гарний – хоча й неповний – ", _jsx(_components.a, {
        href: "http://en.wikibooks.org/wiki/False_Friends_of_the_Slavist",
        children: "огляд можна знайти в англійських Wikibooks"
      }), ". Хоча їх не завжди можна уникнути, до цих слів слід ставитися обережно."]
    }), "\n", _jsxs(_components.p, {
      children: ["Невелика різниця в значеннях між мовами не обов’язково повинна бути проблемою (наприклад, ", _jsx(TransliteratorElement, {
        children: "ljubiti"
      }), " означає «любити» в більшості слов’янських мов, але «подобатися» в польській). Насправді значні відмінності у значеннях також рідко спричиняють проблеми, особливо коли вони належать до різних категорій слів (наприклад, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "pet"
      }), " ~ ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "peť"
      }), " ~ ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "peć"
      }), " ~ ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "piec"
      }), ", що мають такі значення, як «п’ять», «піч» , «недопалок» і «співати»). В обох випадках ймовірність непорозумінь невелика. Фальшиві друзі є проблематичними лише тоді, коли слово, незважаючи на серйозну різницю в значенні, все ж може використовуватися в тому самому чи подібному контексті, а отже, ймовірно, буде по-різному розумітися слов’янами різних національностей. Вищезгадане слово", _jsx(TransliteratorElement, {
        children: "listopad"
      }), ", що означає «листопад» польською/чеською та «жовтень» хорватською, є прикладом. Очевидно, таких слів у міжслов’янських текстах слід уникати."]
    }), "\n", _jsx(_components.h3, {
      id: "neologisms",
      children: "Неологізми"
    }), "\n", _jsxs(_components.p, {
      children: ["У міжслов'янському контексті неологізми - це слова, яких немає як таких в жодній із живих слов'янських мов. Прикладами таких слів є слова портманто (наприклад ", _jsx(TransliteratorElement, {
        children: "katka"
      }), " «качка», з рус. ", _jsx(TransliteratorElement, {
        children: "utka"
      }), ", пол. ", _jsx(TransliteratorElement, {
        children: "kaczka"
      }), ", південнослов’ян. ", _jsx(TransliteratorElement, {
        children: "patka"
      }), "), кальки з неслов’янських мов (наприклад ", _jsx(TransliteratorElement, {
        children: "kolokrěslo"
      }), " «інвалідний візок»), поєднання міжслов’янських коренів слів із міжслов’янськими афіксами, яких немає в слов’янській (наприклад, ", _jsx(TransliteratorElement, {
        children: "gradnik"
      }), " «міщанин, громадянин»), а також слова більш описового характеру у випадках, коли неможливо знайти широко зрозуміле слов'янське слово."]
    }), "\n", _jsxs(_components.p, {
      children: ["Думки щодо того, наскільки штучно створені слова прийнятні в міжслов’янській мові, є різними; одні люблять їх, інші ненавидять. У словнику ми прагнемо уникати неологізмів, якщо тільки в жодній із живих слов’янських мов немає слова, зрозумілого ширшій аудиторії та не сприйнятого іншими. Прикладом є ", _jsx(TransliteratorElement, {
        children: "časina"
      }), " «година» (у старослов’янській є два слова: ", _jsx(TransliteratorElement, {
        children: "čas"
      }), " та ", _jsx(TransliteratorElement, {
        children: "godina"
      }), ", але перше означає «час» у західнослов’янській, друге означає «рік» у південнослов’янській, тоді як серб. -Хорватське слово ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "hbs",
        children: "sat"
      }), " це турецьке слово, зовсім не зрозуміле іншим слов'янам)."]
    }), "\n", _jsx(_components.h3, {
      id: "how-to-establish-the-right-form-for-a-root",
      children: "Як встановити правильну форму для кореня?"
    }), "\n", _jsx(_components.p, {
      children: "Коли ми дізнаємося, яке слово будемо використовувати, наступним кроком буде встановлення того, як саме воно має виглядати. Перш за все, має бути внутрішня узгодженість: щоразу, коли певний корінь чи морфема зустрічається у складі, він повинен мати однакову форму, незалежно від того, з якої конкретної мови ця сполука взята. Щоб міжслов’янська мова не стала сумішшю слів, зібраних із різних мов, слова ніколи не запозичуються безпосередньо з жодної слов’янської мови."
    }), "\n", _jsxs(_components.p, {
      children: ["Замість цього ми повертаємося до гіпотетичної форми в праслов’янській мові, яку часто можна знайти в її близькій спорідненості староцерковнослов’янській, і згодом піддаємо її ", _jsx(_components.a, {
        href: "/uk/learn/vocabulary/derivation#proto-slavic",
        children: "моделі для простого виведення"
      }), ". Це не тільки гарантує зв’язність, але також покращує розбірливість і полегшує навчання, оскільки фонологічний розвиток сучасних слов’янських мов від праслов’янської має тенденцію до надзвичайно регулярності: як тільки людина знає, як даний звук у її власній мові представлений у Міжслов’янський – про що він дізнається дуже швидко, прочитавши кілька текстів – він зможе не тільки легко розпізнавати слова, але й передбачати їх, не звіряючись зі словником."]
    }), "\n", _jsxs(_components.p, {
      children: ["Наприклад, спільнослов’янські послідовності ", _jsx(_components.code, {
        children: "tj/dj"
      }), " стають ", _jsx(_components.code, {
        children: "č/ž"
      }), " у східнослов’янській, ", _jsx(_components.code, {
        children: "c/dz"
      }), " у польській, ", _jsx(_components.code, {
        children: "c/z"
      }), " у чехо-словацькій, ", _jsx(_components.code, {
        children: "č/j"
      }), " у словенській, ", _jsx(_components.code, {
        children: "ć/đ"
      }), " у сербохорватській, ", _jsx(_components.code, {
        children: "ḱ/ǵ"
      }), " у македонською та ", _jsx(_components.code, {
        children: "št/žd"
      }), " болгарською. Найкращим компромісом тут є, ймовірно, ", _jsx(_components.code, {
        children: "č/dž"
      }), " (наприклад, ", _jsx(TransliteratorElement, {
        children: "svěča"
      }), " «свічка» і ", _jsx(TransliteratorElement, {
        children: "medžu"
      }), " «між»), який має додаткову перевагу в тому, що останній є голосовим еквівалентом першого, і таким чином створює симетрію."]
    }), "\n", _jsxs(_components.p, {
      children: ["Щоб проілюструвати, як усе це працює, ви можете побачити [тут] ", _jsx(_components.a, {
        href: "http://steen.free.fr/interslavic/slavic_pronouns.html",
        children: "5"
      }), ", як особисті займенники в міжслов’янській мові засновані на особистих займенниках у природних слов’янських мовах."]
    }), "\n", _jsx(_components.h2, {
      id: "grammar",
      children: "Граматика"
    }), "\n", _jsx(_components.p, {
      children: "Те, що стосується лексики, також стосується граматики. Вихідною точкою завжди є граматичні елементи, спільні для слов’янських мов. Однак кінцевий результат дуже залежить від мети та обставин, для яких використовується Interslavic. Оптимізація розбірливості автоматично ускладнює мову для того, хто говорить або пише, тоді як більш спрощена граматика робить мову менш природною, а отже, важчою для розуміння. Щоб впоратися з цим, ми розрізняємо два різних рівня граматики. Який з них є кращим для якої мети, залежить як від мовця, так і від слухача, середовища та ситуації. В ідеалі рівень 1 має бути підмножиною рівня 2, щоб учень міг поступово просуватися вперед, не анулюючи отримані раніше знання."
    }), "\n", _jsx(_components.h3, {
      id: "simple-level",
      children: "Простий рівень"
    }), "\n", _jsxs(_components.p, {
      children: ["Найпростіша форма міжслов’янської мови, ", _jsx(TransliteratorElement, {
        children: "Slovianto"
      }), ", насправді не є мовою, а скоріше методом, який можуть використовувати неслов’яни як метод вивчення та/або використання міжслов’янської мови. Він складається з трьох різних рівнів, кожен з яких наближає учня до «справжньої» міжслов’янської мови."]
    }), "\n", _jsx(_components.p, {
      children: "Перший рівень - це мінімалістична, примітивна граматика, яка характеризується відсутністю всього, що насправді не потрібно для простого спілкування. Граматичний рід не відіграє ролі на цьому рівні, відмінки іменників відсутні, а дієслівне відмінювання зведено до мінімуму. Кілька форм, що залишилися (наприклад, множини), повинні бути впізнавані для слов’ян без будь-якого попереднього вивчення, і їхнє запам’ятовування повинно займати хвилини, а не години. Цей рівень особливо корисний для неслов'ян, які не зацікавлені у вивченні мови в цілому, але все ж хочуть мати можливість висловлюватися на базовому рівні під час спілкування зі слов'янами."
    }), "\n", _jsx(_components.p, {
      children: "Другий рівень представляє граматичний рід і надає просту модель відмінювання дієслів. Третій рівень знайомить з відмінками іменників."
    }), "\n", _jsx(_components.h3, {
      id: "advanced-level",
      children: "Просунутий рівень"
    }), "\n", _jsx(_components.p, {
      children: "«Справжня» міжслов’янська насамперед призначена для слов’ян, а також для неслов’ян, які хочуть мати можливість спілкуватися на більш серйозному рівні. Цей рівень заснований на спільності слов'янських мов. Таким чином, воно має граматичний рід (є в усіх слов'янських мовах), сім відмінків (є в усіх слов'янських мовах, крім болгарської та македонської), дієслівний аспект і повне відмінювання дієслів. Однак слов’янські мови сумно відомі своїми складними граматиками, і щоб уникнути нескінченних таблиць із номінальними та дієслівними парадигмами, все ще потрібно значне спрощення. Щоб знайти хороший баланс між натуралізмом і простотою, ми намагаємося якомога ближче наблизитися до природних форм, використовуючи найпростіші засоби. Нерегулярності уникають, за винятком випадків, коли легке розпізнавання є серйозною загрозою. Також уникають штучності."
    }), "\n", _jsxs(_components.p, {
      children: ["Найважливішим є те, що кожне граматичне закінчення миттєво впізнається, навіть якщо відмінювана форма слова виглядає інакше в чиїйсь рідній мові. Наприклад, більшість слов’янських мов можуть мати різні закінчення для родового відмінка однини іменника чоловічого роду, але є одне спільне закінчення: ", _jsx(_components.code, {
        children: "-a"
      }), ", яке, отже, є рішенням для всіх входжень цієї форми. У випадку дієслів численні вербальні класи, які існують у слов’янській мові, зведені до простої системи двох форм: інфінітива та форми теперішнього часу. Останнє майже завжди є логічним результатом першого, і лише в деяких випадках їх потрібно вивчати окремо. Завдяки цьому підходу досягається значне спрощення без шкоди для натуралістичного характеру мови."]
    }), "\n", _jsx(_components.p, {
      children: "Цей рівень підходить для контактів і публікацій, а також як засіб для розуміння природи слов'янства."
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

